// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"218d668f","170":"77f59a85","190":"295e8bbe","357":"6a02b3a2","739":"2e522b4c","849":"564f7d97","894":"b750d451","898":"17353da8"}[chunkId] + ".chunk.js";
};